import { MouseEvent } from 'react';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button, IconName, Stack, Typography } from '@optimus-web/core';

interface RadioButtonWithCounterProps {
    label: React.ReactNode;
    totalCount: number;
    selectedItemsCount: number;
    isSelected: boolean;
    onDialogOpen: (e: MouseEvent) => void;
    buttonTestId: string;
}

export const RadioButtonLabelWithCounter = ({
    label,
    totalCount,
    selectedItemsCount,
    isSelected,
    onDialogOpen,
    buttonTestId,
}: RadioButtonWithCounterProps) => (
    <Stack itemAlignment="center">
        {label}
        {isSelected && (
            <>
                {UnicodeEntity.NoBreakSpace}
                <Typography textStyle="bodyMedium" variant="secondary" as="div">
                    {UnicodeEntity.LeftParenthesis}
                    {selectedItemsCount}
                    {UnicodeEntity.ForwardSlash}
                    {totalCount}
                    {UnicodeEntity.RightParenthesis}
                </Typography>
                {UnicodeEntity.NoBreakSpace}
                <Button
                    size="small"
                    icon={IconName.Edit}
                    onClick={onDialogOpen}
                    type="submit"
                    data-test-id={buttonTestId}
                >
                    <LocalizedText textKey={TextKey.Edit} />
                </Button>
            </>
        )}
    </Stack>
);
